import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from "@angular/core";

import { FormControl, Validators, FormGroup, FormBuilder } from "@angular/forms";
import { Button } from "app-core";
import { DoctorsAppointmentDummyDataService } from "app-service";
import { Subject, takeUntil } from "rxjs";

import ButtonType = Data.Core.ButtonType;

@Component({
  selector: 'app-dummy-data-appointments',
  templateUrl: './appointments.component.html',
  styleUrls: ['./appointments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [DoctorsAppointmentDummyDataService]
})
export class DummyDataDoctorsAppointmentComponent {
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  public doctorIDControl = new FormControl('', Validators.required);
  public appointmentsForm!: FormGroup;
  public appointmentCount: number = 0;
  public createAppointmentButton: Button = new Button({
    label: 'Create Appointments',
    type: ButtonType.button,
    action: () => this.createDummyAppointments(this.doctorIDControl.value!.toString()),
    disabled: () => !this.appointmentsForm!.valid,
  });

  public constructor(
    private readonly _cdRef: ChangeDetectorRef,
    private readonly _formBuilder: FormBuilder,
    private readonly _appointmentDummyDataService: DoctorsAppointmentDummyDataService
  ) {
    this.appointmentsForm = this._formBuilder.group([this.doctorIDControl]);
  }

  public ngOnInit(): void {
    this.getDummyAppointmentsCount();
  }

  private createDummyAppointments(doctorId: string): void {
    this._appointmentDummyDataService.createAppointment(doctorId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        () => { },
        () => { },
        () => {
          this.getDummyAppointmentsCount();
        }
      );
  }

  private getDummyAppointmentsCount(): void {
    this._appointmentDummyDataService.getTotalAppointmentsCount()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (count: any) => {
          this.appointmentCount = count.count;
          this._cdRef.markForCheck();
        }
      );
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
